import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'

const baseClass = 'priceRanges'

function renderKeyField(h, item, index) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.key,
        label: this.getTranslate(`${Services.tariffs}.labels.priceRanges.key`),
        dense: true,
        details: false,
        mask: /^[1-9]\d*$/,
        disabled: index === this.firstKeyIndex && this.parseKey(item.key) === 1
      },
      on: {
        input: event => {
          item.key = event
        }
      }
    }
  )
}
function renderPriceField(h, item) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.price,
        label: this.getTranslate(`${Services.tariffs}.labels.priceRanges.price`),
        dense: true,
        details: false,
        mask: regExp.positiveNumberFourSymbolsAfterDot,
        suffix: this.getTranslate('currency.RUB.symbol.unicode'),
        processValue: value => {
          return value?.toString().replace(',', '.')
        }
      },
      on: {
        input: event => {
          item.price = event
        }
      }
    }
  )
}
function renderItem(h, item, index) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-item`
    },
    [
      renderKeyField.call(this, h, item, index),
      renderPriceField.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-dialog`
    },
    [
      h(
        generatorRow,
        {
          props: {
            value: this.items,
            min: 1,
            defaultValue: {
              key: undefined,
              price: undefined
            }
          },
          scopedSlots: {
            row: ({ item, index }) => {
              return renderItem.call(this, h, item, index)
            }
          },
          on: {
            input: event => {
              this.items = event
            }
          }
        }
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-dialog__footer`,
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      ),

      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.save'),
            mode: buttonModes.flat,
            color: Colors.primary,
            disabled: !this.canSave
          },
          on: {
            click: () => {
              return this.saveHandler()
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.getTranslate(`${Services.tariffs}.titles.${baseClass}`),
        maxWidth: 400
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderItems.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

